var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"inline":_vm.inline,"label-width":_vm.labelWidth,"label-position":_vm.labelPosition}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }